import { render, staticRenderFns } from "./NotList.vue?vue&type=template&id=68e7a390&scoped=true"
import script from "./NotList.vue?vue&type=script&lang=ts"
export * from "./NotList.vue?vue&type=script&lang=ts"
import style0 from "./NotList.vue?vue&type=style&index=0&id=68e7a390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e7a390",
  null
  
)

export default component.exports